export function initQuantitySelectors(root: Document | Element = document): void {
  const counters = root.querySelectorAll<HTMLElement>('.js-quantity-counter');
  const priceEl = root.querySelector<HTMLElement>('.js-price-value');
  const unitPrice = priceEl
    ? Number(priceEl.dataset.unitPrice?.replace(/\s+/g, ''))
    : 0;

  counters.forEach((counter) => {
    const input = counter.querySelector<HTMLInputElement>('.js-quantity-input');
    const decBtn = counter.querySelector<HTMLButtonElement>('.js-decrement-btn');
    const incBtn = counter.querySelector<HTMLButtonElement>('.js-increment-btn');

    if (!input || !decBtn || !incBtn)
      return;

    const updatePrice = () => {
      if (!priceEl)
        return;
      const qty = Math.max(1, Number.parseInt(input.value, 10) || 1);
      priceEl.textContent = (unitPrice * qty)
        .toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    };

    decBtn.addEventListener('click', () => {
      input.value = String(Math.max(1, Number.parseInt(input.value, 10) - 1));
      updatePrice();
    });

    incBtn.addEventListener('click', () => {
      input.value = String((Number.parseInt(input.value, 10) || 1) + 1);
      updatePrice();
    });

    updatePrice();
  });
}
